<div class="container mat-typography">
  <mat-card>
    <form [formGroup]="transactionForm" (ngSubmit)="submit()">
      <div fxLayout="column">
        <mat-form-field>
          <mat-label> {{ 'labels.inputs.Amount' | translate }} </mat-label>
          <input matInput required autofocus formControlName="amount" />
          <mat-error *ngIf="transactionForm.controls.amount.hasError('required')">
            {{ 'labels.inputs.Amount' | translate }} {{ 'labels.commons.is' | translate }}
            <strong>{{ 'labels.commons.required' | translate }}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field (click)="transactionDatePicker.open()">
          <mat-label> {{ 'labels.inputs.Transaction date' | translate }} </mat-label>
          <input
            matInput
            [min]="minDate"
            [matDatepicker]="transactionDatePicker"
            required
            formControlName="transactionDate"
          />
          <mat-datepicker-toggle matSuffix [for]="transactionDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #transactionDatePicker></mat-datepicker>
          <mat-error *ngIf="transactionForm.controls.transactionDate.hasError('required')">
            {{ 'labels.inputs.Transaction date' | translate }} {{ 'labels.commons.is' | translate }}
            <strong>{{ 'labels.commons.required' | translate }}</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="5px">
        <button type="button" mat-raised-button [routerLink]="['../../..', 'general']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!transactionForm.valid">
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </div>
    </form>
  </mat-card>
</div>
